/** Español. See `en.ts` for what each key is and what it has to fit.
 *
 * The rail glyphs stay on the Latin WMO symbols; the pressure centers take
 * the Spanish chart convention, A / B (anticiclón / borrasca). */

import type { MessageKey } from "./en";

export const es: Record<MessageKey, string> = {
  metaDescription:
    "Mapas meteorológicos en vivo y gratuitos en el navegador: pronósticos GFS, ECMWF y AIFS, animaciones de radar y satélite, trayectorias de tifones, radar 3D y diagramas skew-T.",
  pageTitleLive: "Mapa de predicción: {variable} · {model} {hours}H",
  pageTitleLiveObservation: "Mapa de observación: {variable} · {model} · últimas {hours} h",
  mapAria: "Mapa global de predicción de temperatura y precipitación",
  modelSwitchAria: "Conjunto de datos",
  variableSwitchAria: "Variable meteorológica",
  varTemp: "2M",
  varPrecip: "TASA",
  varWind: "10M",
  varSolar: "FLUJO",
  varRadar: "CREF",
  varOrog: "OROG",
  varInfrared: "IR 10,4",
  varShortwave: "IR 3,9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "COLOR",
  varGust: "RACHA",
  varCloud: "TOTAL",
  varCape: "SUELO",
  varPwat: "COLUMNA",
  varPtype: "TIPO",
  varCin: "INHIB",
  varHpbl: "ALTURA",
  varVis: "VISIB",
  varDewPoint: "2M",
  varFeelsLike: "2M",
  varOmega: "VERT",
  varThetaE: "EQUIV",
  varCat: "EDR",
  varInflow: "FLUJO",
  varFront: "FRENTE",
  varHotspot: "FOCOS",
  varFfwi: "TIEMPO FUEGO",
  varFwalert: "ALERTA",
  varSst: "PIEL",
  varIce: "COBERT.",
  varWave: "ALTURA",
  varAod: "TOTAL",
  varPm: "2.5",
  varDustsfc: "SUELO",
  varTsoil: "CAPA 1",
  varSoilw: "CAPA 1",
  varHumidity: "REL",
  varVapourFlux: "FLUJO",
  varPressure: "NIV MAR",
  varHeight: "ALTURA",
  varPressureField: "CAMPO",
  varUnknownLayer: "CAPA",

  glyphTmp2m: "T",
  glyphPrate: "R",
  glyphWind10m: "W",
  glyphDswrf: "S",
  glyphCref: "Z",
  glyphIr104: "I",
  glyphIr039: "C",
  glyphDustrgb: "P",
  glyphDustcf: "C",
  glyphZhouye: "Z",
  glyphTruecolor: "C",
  glyphGust: "G",
  glyphTcdc: "N",
  glyphCape: "C",
  glyphVis: "V",
  glyphPwat: "P",
  glyphCin: "I",
  glyphHpbl: "B",
  glyphPtype: "Y",
  glyphDpt2m: "D",
  glyphAptmp2m: "A",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "H",
  glyphFront: "F",
  glyphHotspot: "F",
  glyphFfwi: "T",
  glyphFwalert: "A",
  glyphTmpsfc: "S",
  glyphIce: "I",
  glyphWave: "H",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "P",
  glyphTsoil: "E",
  glyphSoilw: "M",
  glyphPressure: "P",
  glyphRh: "U",
  glyphQflux: "F",
  tipTemp: "Temperatura",
  tipHumidity: "Humedad relativa",
  tipWind: "Viento",
  tipPressure: "Presión y altura geopotencial",
  tipVapourFlux: "Flujo de vapor de agua",
  tipCloud: "Nubosidad",
  tipOmega: "Velocidad vertical",
  tipThetaE: "Temperatura potencial equivalente",
  tipCat: "Turbulencia en aire claro",
  tipIce: "Hielo marino",
  tipWave: "Oleaje",
  tipAod: "Espesor óptico de aerosoles",
  tipPm: "Material particulado",
  tipTsoil: "Temperatura del suelo",
  tipSoilw: "Humedad del suelo",
  tipSatellite: "Imagen de satélite",
  levelSwitchAria: "Nivel",
  levelCaption: "Nivel",
  linesCaption: "Isolíneas",
  accumCaption: "Acumulado",
  accumRateGloss: "intensidad",
  accumTotalGloss: "acumulado {window}",
  modelHeading: "Conjuntos de datos",
  linesRemoveTitle: "Pulsa de nuevo para quitar las isolíneas",
  fieldSectionAria: "Campo",
  overlaySectionAria: "Superposiciones",
  markSectionAria: "Marcas",
  tipMore: "Todas las capas de esta pasada",
  varMore: "Capas",
  glyphMore: "+",
  fieldSheetAria: "Capas",
  fieldSheetHeading: "Capas",
  fieldGroupTemperature: "Temperatura",
  fieldGroupMoisture: "Humedad",
  fieldGroupSoil: "Suelo",
  fieldGroupWind: "Viento",
  fieldGroupDynamics: "Dinámica",
  fieldGroupRadiation: "Radiación y visibilidad",
  fieldGroupAerosol: "Aerosoles y calidad del aire",
  fieldGroupOcean: "Océano",
  fieldGroupHydrology: "Ríos e inundaciones",
  fieldGroupSatellite: "Satélite",
  fieldGroupOther: "Otras",
  fieldGroupImagery: "Imágenes diarias: NASA GIBS",
  gibsTrueColor: "REAL",
  gibsFalseColor: "FUEGO",
  gibsTipTrue: "Color real",
  gibsTipFire: "Falso color de fuego: quemas en rojo oscuro",
  varParticles: "FLUJO",
  glyphParticles: "≈",
  varVolume: "NUBE 3D",
  glyphVolume: "Q",
  levelAlone: "Solo líneas",
  levelAloneTitle: "Solo las líneas: el campo se quita; pulsa de nuevo para recuperarlo",
  creditsTrigger: "Fuentes",
  creditsHeading: "Datos y créditos",
  creditsGfs: "Datos de predicción: GFS 0.25° y sflux",
  creditsHrrr: "Datos de predicción: HRRR 3 km, EE. UU. contiguos",
  creditsGefsAero: "Pronóstico de aerosoles: GEFS-Aerosols 0,25°, AOD y partículas en superficie",
  creditsCmaDust: "Pronóstico de polvo: CMA-CW v1.0/DUST (WMO SDS-WAS Asian Center) 0,15° sobre Asia, vía WMO WIS2",
  creditsSilam: "Pronóstico de calidad del aire: FMI SILAM v6.1 global 0,2°, CC BY 4.0",
  creditsCfs: "Predicción estacional: CFSv2, 9 meses, cada 6 horas",
  creditsEcmwf: "Contiene datos ECMWF modificados, CC BY 4.0",
  creditsIfsHres: "Adaptado del IFS de ECMWF por ECMWF, bajo licencia CC BY 4.0; vía Open-Meteo; IFS HRES ~9 km, remuestreado a 0,1°",
  creditsMrms: "Observaciones de radar: MRMS, EE. UU. contiguos",
  creditsNexrad: "Radar individual: reflectividad y velocidad radial, EE. UU.",
  creditsJma: "Precipitación radar: nowcast JMA, Japón (remallado)",
  creditsHimawari: "Imágenes de satélite: Himawari-9 AHI, JMA, vía NOAA Open Data (reproyectado)",
  creditsGoes: "Imágenes de satélite: GOES-19 Este y GOES-18 Oeste ABI, NOAA NESDIS, vía NOAA Open Data (reproyectado)",
  creditsMeteosat: "Imágenes de satélite: contiene datos Meteosat de EUMETSAT modificados {year}; Meteosat-12 FCI, ciclo horario, CC-BY-4.0 (reproyectado)",
  creditsSounding: "Radiosondeos: TEMP GTS vía WIS2, servicios meteorológicos nacionales",
  creditsAirport: "METAR y TAF de aeropuertos: servicios meteorológicos vía NOAA/NWS AWC",
  creditsFirms: "Incendios activos: LANCE FIRMS NRT, VIIRS 375 m y MODIS, NASA ESDIS",
  creditsGibs: "Imágenes diarias: reflectancia corregida MODIS y VIIRS, NASA ESDIS",
  creditsRadar: "Mosaico radar",
  creditsBasemap: "Mapa base: © colaboradores de OpenStreetMap",
  creditsTerrain: "Relieve del terreno: © Mapterhorn, fuentes de datos de elevación",
  creditsPeaks: "Nombres y altitudes de cumbres: CC0",
  creditsCode: "Código fuente: ringsaturn/xue",
  caseTag: "Caso",
  caseSummaryAria: "Resumen del caso",
  runCycle: "Pasada del modelo",
  recordSpan: "Período del registro",
  latestObservation: "Última observación",
  latestNowcast: "Última predicción inmediata",
  awaitingData: "Esperando datos",
  validTimeLabel: "Hora de validez",
  observationTimeLabel: "Hora de observación",
  statsAria: "Estadísticas detalladas",
  statsCloseAria: "Cerrar estadísticas",
  bufferedFrames: "En memoria",
  downloadedBytes: "Descargado",
  formatLabel: "Formato",
  formatZarr: "Zarr",
  preloadProgressAria: "Progreso de la precarga de datos de predicción",
  statDataset: "Conjunto de datos",
  statGrid: "Malla",
  statFrameCache: "Caché de fotogramas",
  statDecodeTime: "Tiempo de decod.",
  statDecodeRate: "Ritmo de decod.",
  statViewport: "Muestreo",
  statConnection: "Conexión",
  awaitingManifest: "Esperando el manifiesto",
  legendPrateAria: "Escala de color de la intensidad de precipitación",
  timelineAria: "Controles de tiempo de la predicción",
  playAnimation: "Reproducir animación",
  pauseAnimation: "Pausar animación",
  playbackSpeed: "Velocidad de reproducción",
  exportOpenAria: "Exportar la animación",
  exportSheetAria: "Exportar la animación",
  exportHeading: "Exportar",
  exportFormat: "Formato",
  exportSize: "Tamaño",
  exportFps: "Fotogramas/s",
  exportRange: "Fotogramas",
  exportFrom: "Desde",
  exportTo: "Hasta",
  exportRun: "Exportar",
  exportCancel: "Cancelar",
  exportSummary: "{size}, {frames} fotogramas, {seconds} s, unos {bytes}",
  exportCapturing: "Capturando {done}/{total}",
  exportEncoding: "Codificando {percent} %",
  exportFailed: "Error al exportar",
  readingManifest: "Cargando el manifiesto",
  forecastHourAria: "Hora de predicción",
  forecastDaysAria: "Tramos diarios de predicción",
  observationDaysAria: "Tramos diarios",
  mapMenuAria: "Opciones del mapa",
  menuStats: "Estadísticas detalladas",
  menuCopyDebug: "Copiar información de depuración",
  errorTitle: "Datos no disponibles",
  retry: "Reintentar",
  langPickerAria: "Idioma",
  langPickerHeading: "Idioma",
  themeToggleAria: "Alternar claro / oscuro",
  viewGlobeAria: "Globo",
  viewTerrainAria: "Relieve 3D",
  viewContoursAria: "Curvas de nivel",
  viewResetNorthAria: "Orientar al norte",
  viewResetPitchAria: "Restablecer inclinación",
  viewBoxAria: "Primer plano de la tormenta: arrastra un recuadro",
  viewSectionAria: "Corte vertical: arrastra una línea",
  viewDistanceAria: "Medir distancia: haz clic en los puntos y otra vez en el último para terminar",
  viewAreaAria: "Medir área: haz clic en los vértices y otra vez en el primero o el último para terminar",
  particlesToggle: "Partículas",
  particlesToggleAria: "Alternar la animación de partículas de viento",

  dataInterrupted: "Carga de datos interrumpida",
  errorHint: "{message}. Comprueba que se ha ejecutado make mvp y que la página se sirve con make serve.",
  loadFailed: "Error al cargar",
  webglLost: "WebGL no disponible: cierra el navegador por completo y vuelve a abrirlo",
  saveData: "ahorro",
  debugCopied: "Información de depuración copiada",
  copyFailed: "Error al copiar",
  bundleResident: "Paquete totalmente en memoria",
  viewportResident: "Vista actual totalmente cargada",
  streamingOnDemand: "Transmisión bajo demanda",
  receivingBundle: "Recibiendo el paquete de predicción",
  receivingBundlePercent: "Recibiendo el paquete {percent}%",
  readingIndex: "Leyendo el índice de datos",
  initializingDecoder: "Inicializando el decodificador",
  framesReady: "{count} fotogramas listos",
  readingData: "Cargando datos",
  bundleLoadFailed: "No se pudo cargar el paquete de predicción",
  workerStartFailed: "El worker de decodificación no arrancó",
  decodeFailed: "Error de decodificación",
  frameDecodeFailed: "Error al decodificar el fotograma: {message}",
  legendAria: "Escala de color de {label}",
  legendInflow: "Flujo cálido y húmedo",
  legendFront: "Zona frontal (gradiente θe)",
  legendHotspot: "Foco de calor (prueba contextual a 3,9 µm)",
  legendFfwi: "Índice meteorológico de incendios de Fosberg",
  legendFwalert: "Humedad relativa bajo 30 % con rachas de 10 m/s o más",
  legendDustDust: "Polvo",
  legendDustThickHigh: "Nubes altas espesas",
  legendDustThinHigh: "Nubes altas finas",
  legendDustMid: "Nubes medias",
  legendDustLow: "Nubes bajas cálidas",
  legendDustDesert: "Superficie desértica caliente",
  legendDustSurface: "Mar y tierra con vegetación",
  legendTruecolorCloud: "Nubes y nieve",
  legendTruecolorSea: "Mar",
  legendTruecolorLand: "Tierra y vegetación",
  legendTruecolorNightCloud: "Nubes de noche (infrarrojo)",
  legendTruecolorNightGround: "Cielo despejado de noche",
  legendPtypeRain: "Lluvia",
  legendPtypeFreezingRain: "Lluvia helada",
  legendPtypeSnow: "Nieve",
  legendPtypeIcePellets: "Gránulos de hielo",
  legendDisrpBelow: "Bajo el nivel de 1,5 años",
  legendDisrp1p5: "≥ nivel de 1,5 años",
  legendDisrp2: "≥ nivel de 2 años",
  legendDisrp5: "≥ nivel de 5 años",
  legendDisrp20: "≥ nivel de 20 años",
  legendCatLight: "Ligera",
  legendCatModerate: "Moderada",
  legendCatModerateSevere: "Moderada–fuerte",
  legendCatSevere: "Fuerte",
  varLabelTmp2m: "Temperatura a 2 m",
  varLabelPrate: "Intensidad de precipitación",
  varLabelDswrf: "Radiación solar",
  varLabelWind10m: "Viento a 10 m",
  varLabelWind80m: "Viento a 80 m",
  varLabelWind100m: "Viento a 100 m",
  varLabelCref: "Reflectividad radar compuesta",
  varLabelRefl3d: "Reflectividad radar 3D",
  varLabelCloud3d: "Agua de nube 3D",
  varLabelOrog: "Orografía",
  varLabelIr104: "Imagen infrarroja (temperatura de brillo a 10,4 µm)",
  varLabelIr039: "Infrarrojo de onda corta (temperatura de brillo a 3,9 µm)",
  varLabelDustrgb: "RGB de polvo (compuesto infrarrojo)",
  varLabelDustcf: "Confianza de polvo DEBRA",
  varLabelZhouye: "Confianza de polvo ZHOUYE",
  varLabelTruecolor: "Color real de día, nubes infrarrojas de noche",
  varLabelGust: "Rachas de viento",
  varLabelTcdc: "Nubosidad total",
  varLabelCape: "Energía potencial convectiva disponible",
  varLabelCin: "Inhibición convectiva",
  varLabelVis: "Visibilidad",
  varLabelDpt2m: "Punto de rocío a 2 m",
  varLabelAptmp2m: "Sensación térmica a 2 m",
  varLabelLcdc: "Nubosidad baja",
  varLabelMcdc: "Nubosidad media",
  varLabelHcdc: "Nubosidad alta",
  varLabelPwat: "Agua precipitable",
  varLabelHpbl: "Altura de la capa límite planetaria",
  varLabelPtype: "Tipo de precipitación",
  varLabelTmpsfc: "Temperatura superficial del mar (temperatura de la superficie en tierra)",
  varLabelIcec: "Cobertura de hielo marino",
  varLabelIcetk: "Espesor del hielo marino",
  varLabelWave: "Oleaje: altura significativa y dirección",
  varLabelHtsgw: "Altura significativa del oleaje",
  varLabelPerpw: "Periodo del oleaje primario",
  varLabelDirpw: "Dirección del oleaje primario",
  varLabelWindwave: "Mar de viento: altura significativa y dirección",
  varLabelSwell: "Mar de fondo: altura significativa y dirección (primera componente)",
  varLabelWvhgt: "Altura significativa del mar de viento",
  varLabelWvper: "Periodo medio del mar de viento",
  varLabelWvdir: "Dirección del mar de viento",
  varLabelSwhgt: "Altura significativa del mar de fondo (primera componente)",
  varLabelSwper: "Periodo medio del mar de fondo (primera componente)",
  varLabelSwdir: "Dirección del mar de fondo (primera componente)",
  varLabelAod: "Espesor óptico de aerosoles a 550 nm",
  varLabelAoddust: "Espesor óptico del polvo",
  varLabelAodsalt: "Espesor óptico de la sal marina",
  varLabelAodsulf: "Espesor óptico del sulfato",
  varLabelAodorg: "Espesor óptico del carbono orgánico",
  varLabelAodbc: "Espesor óptico del carbono negro",
  varLabelPm25: "Concentración de PM2,5 en superficie",
  varLabelPm10: "Concentración de PM10 en superficie",
  varLabelPm10dust: "Concentración de PM10 de polvo en superficie",
  varLabelDustsfc: "Concentración de polvo en superficie",
  varLabelTsoil1: "Temperatura del suelo, capa 1",
  varLabelTsoil2: "Temperatura del suelo, capa 2",
  varLabelTsoil3: "Temperatura del suelo, capa 3",
  varLabelTsoil4: "Temperatura del suelo, capa 4",
  varLabelSoilw1: "Humedad volumétrica del suelo, capa 1",
  varLabelSoilw2: "Humedad volumétrica del suelo, capa 2",
  varLabelSoilw3: "Humedad volumétrica del suelo, capa 3",
  varLabelSoilw4: "Humedad volumétrica del suelo, capa 4",
  varLabelPrmsl: "Presión a nivel del mar",
  varLabelHeightAtLevel: "Altura geopotencial de {level} hPa",
  varLabelTempAtLevel: "Temperatura de {level} hPa",
  varLabelRhAtLevel: "Humedad relativa de {level} hPa",
  varLabelSpfhAtLevel: "Humedad específica de {level} hPa",
  varLabelWindAtLevel: "Viento de {level} hPa",
  varLabelQfluxAtLevel: "Flujo de vapor de agua de {level} hPa",
  varLabelVvelAtLevel: "Velocidad vertical a {level} hPa",
  varLabelThetaeAtLevel: "Temperatura potencial equivalente a {level} hPa",
  varLabelCatAtLevel: "Turbulencia en aire claro a {level} hPa (EDR)",
  legendSubtropicalHigh: "línea 588",
  webglUnavailable: "Este navegador no ofrece un contexto WebGL2",
  pointerRequestFailed: "La petición del puntero en vivo devolvió HTTP {status}",
  manifestRequestFailed: "La petición del manifiesto devolvió HTTP {status}",
  bundleRequestFailed: "La petición del paquete devolvió HTTP {status}",
  bundleTooLong: "El paquete supera la longitud declarada por el manifiesto",
  bundleLengthMismatch: "La longitud del paquete no coincide con el manifiesto",
  bundleChecksumMismatch: "La suma de verificación del paquete no coincide",
  bundleRunMismatch: "La pasada del paquete no coincide con el manifiesto",
  bundleMissingVariable: "Al paquete le falta la variable {id}",
  manifestMissingBundle: "El manifiesto no tiene paquete para la variable {id}",
  mosaicNoMembers: "Ningún conjunto de datos de satélite del mosaico está disponible",

  probeAria: "Serie temporal del punto",
  probeHint: "Reproduce o arrastra para completar la serie",
  probeComplete: "Serie completa",
  probeOutside: "Fuera de la malla de este conjunto de datos",
  probeNoData: "Sin datos en este fotograma",
  probeAwaiting: "Esperando este fotograma",
  probeModelElevationLabel: "Modelo",
  probeDemLabel: "DEM",
  probeCloseAria: "Cerrar los datos del punto",
  cardCloseAria: "Cerrar la ficha",

  centerHigh: "A",
  centerLow: "B",

  showcaseLink: "Casos",
  showcaseBack: "← Todos los casos",
  showcaseHome: "Predicción en vivo",
  showcaseTitle: "Casos de estudio",
  showcaseHeading: "Episodios meteorológicos, repetidos",
  showcaseArchive: "archivo",
  showcaseIntro:
    "Cada caso es un fragmento de un episodio meteorológico pasado — una pasada de predicción archivada, u observaciones — a través del mismo codificador, recortado a la región y las horas en que ocurrió.",
  showcaseMetaDescription:
    "Repeticiones de episodios meteorológicos pasados: conjuntos de datos de predicción y radar recortados para tifones, lluvias intensas, olas de calor y más",
  showcaseLoading: "Cargando el catálogo de casos",
  showcaseEmpty: "Todavía no hay casos publicados",
  showcaseLoadFailed: "No se pudo cargar el catálogo de casos: {message}",
  showcaseCaseMissing: "No hay ningún caso llamado {id}",
  showcaseEventLabel: "Episodio",
  showcaseRunLabel: "Pasada",
  showcaseSeriesLabel: "Inicio",
  showcaseRangeLabel: "Alcance",
  showcaseSpanLabel: "Duración",
  showcaseRegionLabel: "Región",
  showcaseGridLabel: "Malla",
  showcaseSizeLabel: "Tamaño",
  showcaseVariablesLabel: "Campos",
  showcaseHours: "{count} h",
  showcaseCaseAria: "Abrir el caso {title}",
  showcaseListAria: "Lista de casos de estudio",

  tcTileTip: "Ciclones tropicales",
  varTc: "TRAYECT",
  glyphTc: "C",
  tcSheetAria: "Ciclones tropicales",
  tcHeading: "Ciclones tropicales",
  tcAllSystems: "Todos los sistemas numerados",
  tcNone: "Sin sistemas activos",
  tcUnnamed: "Sistema sin nombre",
  tcDisturbances: "Perturbaciones y depresiones",
  tcPotential: "Sistemas potenciales",
  tcPotentialShow: "Mostrar {count} sistemas solo de modelos",
  tcModelOnly: "solo modelo",
  tcAgencies: "Pronósticos oficiales",
  tcModels: "Trayectorias de modelos",
  tcMembers: "Miembros del ensamble",
  tcBest: "Mejor trayectoria",
  tcOptionsAria: "Opciones de ciclones",
  tcHistoryHeading: "Ciclones tropicales pasados",
  tcHistoryIntro: "Cada tormenta numerada del archivo: las trayectorias finales de los centros, cada pronóstico emitido para ella y cuánto se desvió cada uno.",
  tcHistorySeasonsAria: "Temporada",
  tcHistoryBasinsAria: "Cuenca",
  tcHistoryAll: "Todas",
  tcHistoryEmpty: "No hay tormentas con pronósticos en esta temporada y cuenca",
  tcHistoryStormAria: "Abrir {name}",
  tcHistorySouthernNote: "Las temporadas del hemisferio sur van de julio a junio y llevan el año en que terminan: la temporada {season} va de {from} a {to}.",
  tcPageTitle: "Ciclón tropical pasado",
  tcPageMetaDescription: "Un ciclón tropical pasado: las trayectorias finales de los centros, cada pronóstico archivado para él y cuánto se desvió cada uno.",
  tcPageLoading: "Cargando tormenta",
  tcPageMissing: "No hay ninguna tormenta archivada llamada {id}",
  tcPageFailed: "No se pudo cargar la tormenta: {message}",
  tcPageIssue: "Momento",
  tcPageNoForecast: "ningún pronóstico empieza aquí",
  tcPagePrev: "Pronóstico anterior",
  tcPageNext: "Pronóstico siguiente",
  tcPageSources: "Trayectorias visibles",
  tcPageErrorsHeading: "Error de trayectoria, km",
  tcPageTruth: "Frente a la trayectoria final de",
  tcPageSource: "Fuente",
  tcPageErrorsMean: "Media de la tormenta",
  tcPageErrorsThis: "El pronóstico del mapa",
  tcPageErrorsNone: "Ningún pronóstico de esta tormenta se ha verificado aún frente a esta trayectoria final",
  tcPageNote: "Distancia a la trayectoria final en las horas sinópticas, contada solo mientras el sistema es un ciclón tropical o subtropical; un conjunto se evalúa por su media. Los pronósticos oficiales se comparan con modelos iniciados a la misma hora, que terminaron después de emitirse el pronóstico oficial.",
  tcPageId: "Código ATCF",
  tcPageLife: "Vida",
  tcPagePeak: "Viento máximo",
  tcPageForecasts: "Pronósticos",
  tcCardSeasons: "Temporadas",
  tcCardStorms: "Tormentas",
  tcPageDetails: "Página de la tormenta",
  tcPageSeasonList: "Todas las tormentas de la temporada",
  tcCardBrowse: "Por temporada",
  tcPageRadii: "Radios de viento",
  tcLegendIntensity: "Intensidad: trayectoria final de EE. UU., viento de 1 min",

  soundingTileTip: "Radiosondeos",
  varSounding: "ALTURA",
  glyphSounding: "S",
  airportTileTip: "Observaciones de aeropuerto",
  varAirport: "METAR",
  glyphAirport: "A",
  synopTileTip: "Estaciones meteorológicas de superficie",
  varSynop: "SUPERFICIE",
  glyphSynop: "W",
  radarTileTip: "Radar de un sitio",
  varRadarSite: "SITIO",
  glyphRadarSite: "D",
  radarProductAria: "Producto de radar",
  radarLatest: "último",
  radarCloseAria: "Volver al mosaico",
  radarReflectivity: "Reflectividad",
  radarVelocity: "Velocidad radial",
  stationSounding: "Radiosondeo",
  stationAirport: "Aeropuerto",
  stationObserved: "Observado",
  stationFreezingLevel: "Isoterma de 0 °C",
  stationPw: "Agua precipitable",
  stationCategory: "Categoría de vuelo",
  stationVisibility: "Visibilidad",
  stationQnh: "QNH",
  stationLevels: "Niveles",
  stationSynop: "Estación meteorológica",
  stationHumidity: "Humedad",
  stationPrecipitation: "Precipitación",
  stationPressure: "Presión en la estación",
  stationSeaLevelPressure: "Presión a nivel del mar",
  stationSunshine: "Insolación",
  stationSnowDepth: "Espesor de nieve",
  stationElevation: "Altitud",
  stationOpenSounding: "Abrir el sondeo",
  stationPinHere: "Fijar aquí",
  fireTileTip: "Incendios activos (NASA FIRMS, últimas 24 h)",
  varFire: "FUEGOS",
  glyphFire: "F",
  fireDetection: "Incendio activo",
  fireAcquired: "Adquirido",
  fireRadiativePower: "Potencia radiativa",
  fireBrightness: "Temperatura de brillo",
  fireConfidence: "Confianza",
  fireConfidenceLow: "baja",
  fireConfidenceNominal: "nominal",
  fireConfidenceHigh: "alta",
  fireOverpass: "Pasada",
  fireDay: "día",
  fireNight: "noche",
  aqTileTip: "Estaciones de calidad del aire (PM2.5)",
  varAq: "PM2.5",
  glyphAq: "Q",
  aqStation: "Calidad del aire",
  aqAgency: "Organismo",
  aqNetwork: "Red",
  aqPreliminary: "Datos preliminares: sin validar, sujetos a cambios",
  aqDayRange: "PM2.5, últimas 24 h",
  aqNearest: "Estación de calidad del aire más cercana, {km} km",
  alertsTileTip: "Avisos meteorológicos vigentes",
  varAlerts: "AVISOS",
  glyphAlerts: "!",
  alertsCardTitle: "Avisos",
  alertsInForceNow: "Vigentes ahora",
  alertsAsOf: "a las {time}",
  alertsLevel: "Nivel {level}",
  alertsUntilCancelled: "hasta su cancelación",
  alertsIssued: "emitido {time}",
  alertCategoryRain: "Lluvia intensa",
  alertCategoryFlood: "Inundación",
  alertCategoryLandslide: "Deslizamiento",
  alertCategoryWind: "Viento",
  alertCategoryThunderstorm: "Tormenta",
  alertCategorySnowIce: "Nieve y hielo",
  alertCategoryHeat: "Calor",
  alertCategoryCold: "Frío",
  alertCategoryFog: "Niebla",
  alertCategoryDust: "Polvo",
  alertCategoryFire: "Riesgo de incendio",
  alertCategoryAir: "Calidad del aire",
  alertCategoryCoastal: "Costero",
  alertCategoryMarine: "Marítimo",
  alertCategoryTsunami: "Tsunami",
  alertCategoryOther: "Otro",
  markerPlace: "Lugar",
  markerEvent: "Suceso",
  markerSources: "Fuentes",
  caseMarkersAria: "Lugares y sucesos de este caso",
  casePartsAria: "Partes de este suceso",
  riverHeading: "Caudal de los ríos",
  riverTracksAria: "Ejecución del modelo hidrológico",
  riverTrackAnalysis: "Análisis",
  riverTrackForecast: "Previsión {cycle}",
  riverKeyAria: "Caudal frente al habitual",
  riverRatio2: "< 2× lo habitual",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "Coloreado por caudal, en la escala del campo",
  riverExtents: "Zonas inundadas",
  riverGaugeHint: "Los círculos son estaciones de aforo: pulse una para ver su hidrograma.",
  riverObserved: "medido",
  riverModelled: "modelo",
  riverPeaks: "Picos notificados",
  riverGaugeLoading: "cargando…",
  riverGaugeUnavailable: "no disponible",

  soundingObserved: "OBS",
  soundingModel: "MODELO",
  soundingNoModel: "sin modelo en 12 h",
  soundingLoading: "Leyendo el sondeo…",
  soundingUnavailable: "Sondeo no disponible",
  soundingExpand: "Gráfico completo",
  soundingClose: "Cerrar",
  soundingSheetHeading: "Sondeo",
  soundingSheetAria: "Gráfico del sondeo",

  // The comparison page (compare.html).
  compareLink: "Comparar",
  compareTitle: "Comparar predicciones",
  compareHeading: "Comparación de modelos",
  compareEyebrow: "punto",
  compareIntro:
    "Todos los modelos de predicción en vivo en un punto, sobre un mismo reloj: lo que dice cada pasada para las próximas horas, junto a los reportes del aeropuerto más cercano.",
  compareMetaDescription:
    "Compara las predicciones de GFS, ECMWF, AIFS, IFS HRES y HRRR en un punto, hora a hora, con los reportes METAR del aeropuerto más cercano.",
  compareLatitude: "Latitud",
  compareLongitude: "Longitud",
  compareLocate: "Usar mi ubicación",
  compareLocateFailed: "Ubicación no disponible",
  compareOnMap: "En el mapa",
  compareSpan5: "5 días",
  compareSpan15: "15 días",
  compareFieldsAria: "Campos a comparar",
  compareModelsAria: "Bloques de comparación de modelos",
  compareLoading: "Leyendo {model}…",
  compareModelFailed: "{model}: {message}",
  compareOffGrid: "fuera de la malla de este modelo",
  compareNoModels: "Ningún modelo cubre este punto",
  compareHide: "Ocultar",
  compareShow: "Mostrar",
  comparePin: "Fijar arriba",
  compareHidden: "Modelos ocultos",
  compareRun: "Pasada",
  compareObservationsFrom: "Reportes de {icao}",
  compareNoAirport: "Ningún aeropuerto a menos de 40 km",
  compareHours: "Horas",
  compareNow: "ahora",
  compareCells: "Cada valor es la celda de la malla del propio modelo más cercana al punto, nunca una interpolación; las horas se muestran en tu zona horaria.",
  metricsMetaDescription: "Cuándo se publicó cada pasada de pronóstico de Xue, medido en los flujos de publicación: latencia tras la hora de inicio, ciclos que faltan y qué estaba publicado al cierre del mercado diario de ERCOT.",
  metricsHeading: "Llegada de pasadas",
  metricsEyebrow: "medido",
  metricsIntro: "Cuándo se publicó cada pasada de pronóstico en este sitio, según los propios registros de los flujos de publicación: el momento en que se escribió el puntero en vivo y cuánto después de la hora de inicio del modelo fue.",
  metricsNotSla: "Son mediciones, no un nivel de servicio: Xue no asume ningún compromiso de disponibilidad.",
  metricsGenerated: "Generado {time}, últimos {days} días",
  metricsLoading: "Leyendo métricas…",
  metricsEmpty: "Aún no hay métricas. Se generan cada seis horas a partir de los flujos de publicación; vuelva después de la próxima generación.",
  metricsFailed: "No se pudieron leer las métricas: {message}",
  metricsSourcesHeading: "Por fuente",
  metricsLatencyNote: "La latencia va de la hora de inicio al momento en que la pasada se publicó, así que incluye el tiempo de producción del propio modelo. Todas las horas en UTC.",
  metricsTimelineNote: "Cada franja es la ventana: una barra por ciclo publicado, en su hora de inicio, con la latencia como altura frente a la más larga de la fuente; una marca bajo la línea es un ciclo que nunca llegó.",
  metricsTypicalNote: "* Típico aguas arriba: un valor de experiencia de cuándo suelen estar completos los datos del modelo tras su hora de inicio, no una medición. En blanco donde no lo hay.",
  metricsTimelineAria: "Llegadas de {model} en la ventana",
  metricsCadence: "cada {hours} h",
  metricsLatest: "Última pasada",
  metricsLanded: "Publicada a las",
  metricsLatency: "Latencia",
  metricsMedian: "Mediana",
  metricsMax: "Máx.",
  metricsTypical: "Típico aguas arriba",
  metricsCycles: "Ciclos llegados",
  metricsMissing: "Faltan",
  metricsMissingList: "Ciclos que faltan",
  metricsRuns: "Ejecuciones del flujo",
  metricsOutcomeLanded: "publicada",
  metricsOutcomeSkipped: "omitida",
  metricsOutcomeDryRun: "ensayo",
  metricsOutcomeFailed: "fallida",
  metricsBacklog: "{count} ejecuciones del flujo aún sin leer; la próxima generación las lee.",
  metricsDeadlinesHeading: "Al cierre",
  metricsDeadlineIntro: "Para cada día local, la pasada más reciente ya publicada al cierre y la antigüedad de su ciclo en ese momento.",
  metricsSource: "Fuente",
  metricsCommonest: "Habitual",
  metricsNoneLive: "ninguna",
  glyphAurora: "A",
  varAurora: "PROB",
  varDis06: "6H",
  varDisrp: "RP",
  varUpstream: "ÁREA",
  fieldGroupSpace: "Meteorología espacial",
  fieldGroupFire: "Incendios",
  modelGroupForecast: "Modelos de pronóstico",
  modelGroupRadar: "Radar",
  varLabelAurora: "Probabilidad de auroras visibles",
  varLabelDis06: "Caudal fluvial (media de 6 h)",
  varLabelDisrp: "Clase de periodo de retorno",
  varLabelUpstream: "Área de cuenca aguas arriba",
  creditsAurora: "Meteorología espacial: probabilidad de auroras, modelo OVATION de NOAA SWPC",
  creditsEfas: "Caudal fluvial: Copernicus EMS EFAS v5, Europa 1′; solo casos",
  creditsEra5: "Reanálisis: Copernicus C3S ERA5 (ECMWF), global 0,25°, horario, CC-BY-4.0; solo casos",
  creditsCams: "Análisis de aerosoles: Copernicus CAMS (ECMWF), global 0,4°, cada 3 horas, CC-BY-4.0; solo casos",
};
